import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const deleteMember = (userGroupId, userId) => {
  return apiRequestType(
    apiTypes.DELETE,
    apiConstants.ADMIN.GROUP_MANAGEMENT.DELETE_MEMBER(userGroupId, userId)
  );
};

export default deleteMember;
